/**
 * A thin scroll-progress hairline at the very top of the viewport.
 * Pure CSS implementation using scroll-driven animations — no JS reflows.
 * Accessible: hidden from screen readers.
 */
export function ScrollProgressBar() {
  return (
    <div
      className="fixed top-0 left-0 right-0 h-[2px] z-[60] origin-left scroll-progress-bar"
      style={{
        background: 'hsl(var(--primary) / 0.55)',
      }}
      aria-hidden="true"
    />
  );
}
